import gsap from "gsap";

/* -------------------------------------------------- */
/* 📏 Guides */
/* -------------------------------------------------- */

// Create the guides
const guides = document.createElement("div");
guides.className = 'guides wrap';
const guidesInner = document.createElement("div");
guidesInner.className = 'inner grid';
guides.appendChild(guidesInner);
for(let i=0; i<12; i++) { 
  const guide = document.createElement("div");
  guide.className = 'guides__guide';
  guidesInner.appendChild(guide);
}
document.body.appendChild(guides);

// Set up a tween that animates the guides in and out
let toggleGuides = gsap.to(guides, {
  duration: .25,
  ease: 'power2.inOut',
  autoAlpha: 1,
  paused: true
}).reverse();

// Check if the guides was enabled before
if (localStorage.getItem('debug') == 'true') {
  toggleGuides.play().progress(1);
}

// Listen for ⌃G keypresses
document.addEventListener('keydown', e => {
  if (e.key === 'g' && e.ctrlKey) {
    // Toggle the guides when ⌃G is pressed
    toggleGuides.reversed() ? toggleGuides.play() : toggleGuides.reverse();
    // Save the state in local storage
    localStorage.setItem('debug', !toggleGuides.reversed());
  }
})

guides.dataset.windowWidth = window.innerWidth;

window.addEventListener('resize', () => {
  guides.dataset.windowWidth = window.innerWidth;
})

/* -------------------------------------------------- */
/* Call to Action blocks */
/* -------------------------------------------------- */

let callToActionBlocks = document.querySelectorAll('.hero-block');

callToActionBlocks.forEach(block => {

  let images = block.querySelectorAll('.hero-block__image');
  let imageLeft = block.querySelector('.hero-block__image--left');
  let imageRight = block.querySelector('.hero-block__image--right');
  let input = block.querySelector('input[type="email"]');

  let tl = gsap.timeline({
    paused: true,
    defaults: {
      duration: 3,
      ease: 'power3.inOut'
    }
  })

  .fromTo(imageLeft, {
    xPercent: 45,
    rotate: -3,
    scale: .9,
    autoAlpha: 1
  }, {
    rotate: 0,
    xPercent: 0,
    immediateRender: false
  }, 0)

  .fromTo(imageRight, {
    xPercent: -45,
    rotate: 3,
    scale: .9,
    autoAlpha: 1
  }, {
    rotate: 0,
    xPercent: 0,
    immediateRender: false
  }, 0)

  images.forEach((image) => {
    image.addEventListener('click', () => {
      input.focus();
    })
  })

  window.addEventListener('load', (e) => {
    tl.play();
  })

})

/* -------------------------------------------------- */
/* Menu */
/* -------------------------------------------------- */

let menuToggle = document.querySelector('.menu-toggle');
let menu = document.querySelector('.menu');

let menuAnimation = gsap.timeline({
  defaults: {
    ease: 'power1.inOut',
    duration: .25
  },
  paused: true
})

.fromTo(menu, {
  yPercent: -100,
  autoAlpha: 1
}, {
  yPercent: 0,
  autoAlpha: 1,
  immediateRender: false
})

.to(menuToggle.querySelector('rect:nth-child(1)'), {
  y: 11,
  rotate: 45,
  transformOrigin: '50% 50%'
}, 0)

.to(menuToggle.querySelector('rect:nth-child(2)'), {
  autoAlpha: 0,
  scaleX: 0
}, 0)

.to(menuToggle.querySelector('rect:nth-child(3)'), {
  y: -11,
  rotate: -45,
  transformOrigin: '50% 50%'
}, 0)

.to(menuToggle, {
  rotate: 90,
}, 0)

.reverse();

menuToggle.addEventListener('click', () => {
  menuAnimation.reversed() ? menuAnimation.play() : menuAnimation.reverse();
})